import NativePush from './nativePush';

const nativePush = new NativePush();

export default nativePush;
